import { request, downloadFile } from './client';

export const apiGetBooks = (params = '') => request(`/books?${params}`);

export const apiGetBookById = (id) => request(`/books/${id}`);

export const apiCreateBook = (formData) =>
  request('/books', { method: 'POST', body: formData });

export const apiUpdateBook = (id, formData) =>
  request(`/books/${id}`, { method: 'PUT', body: formData });

export const apiDeleteBook = (id) => request(`/books/${id}`, { method: 'DELETE' });

export const apiBulkUpdateBookStatus = (ids, isActive) =>
  request('/books/admin/bulk-status', { method: 'PATCH', body: { ids, isActive } });

export const apiExportBooksXlsx = () => {
  const stamp = new Date().toISOString().slice(0, 10);
  return downloadFile('/books/admin/export', `books-${stamp}.xlsx`);
};

export const apiDownloadBooksTemplate = () =>
  downloadFile('/books/admin/template', 'books-import-template.xlsx');

export const apiImportBooksXlsx = (file, { apply = false } = {}) => {
  const fd = new FormData();
  fd.append('file', file);
  return request(`/books/admin/import?apply=${apply ? 'true' : 'false'}`, {
    method: 'POST',
    body: fd,
  });
};
